import React from "react";

const DailyAcquisitionPerformance = ({ data }) => {
    if (!data) return null;

    return (
        <div className="spd-table-container">
            <h4 className="mb-3">Daily Acquisition Performance Report</h4>

            <div className="table-responsive">
                <table className="table table-bordered">
                    <thead>
                        <tr>
                            <th rowSpan="2">IC Name</th>
                            <th rowSpan="2">Monthly Acquisition<br />Target</th>
                            <th colSpan="4">T-1</th>
                            <th colSpan="4">WTD</th>
                            <th colSpan="4">MTD</th>
                            <th rowSpan="2">% Achievement</th>
                            <th rowSpan="2">Productivity<br />(Acquired/Visited)</th>
                        </tr>
                        <tr>
                            <th>Visited</th>
                            <th>Acquired</th>
                            <th>Lost</th>
                            <th>Follow-up</th>
                            <th>Visited</th>
                            <th>Acquired</th>
                            <th>Lost</th>
                            <th>Follow-up</th>
                            <th>Visited</th>
                            <th>Acquired</th>
                            <th>Lost</th>
                            <th>Follow-up</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.data.map((row, idx) => (
                            <tr key={idx}>
                                <td><strong>{row.icName}</strong></td>
                                <td className="text-center">{row.acquisitionTarget}</td>
                                <td className="text-center">{row.t1.visited || '-'}</td>
                                <td className="text-center">{row.t1.acquired || '-'}</td>
                                <td className="text-center">{row.t1.lost || '-'}</td>
                                <td className="text-center">{row.t1.followup || '-'}</td>
                                <td className="text-center">{row.wtd.visited || '-'}</td>
                                <td className="text-center">{row.wtd.acquired || '-'}</td>
                                <td className="text-center">{row.wtd.lost || '-'}</td>
                                <td className="text-center">{row.wtd.followup || '-'}</td>
                                <td className="text-center">{row.mtd.visited || '-'}</td>
                                <td className="text-center">{row.mtd.acquired || '-'}</td>
                                <td className="text-center">{row.mtd.lost || '-'}</td>
                                <td className="text-center">{row.mtd.followup || '-'}</td>
                                <td className="text-center">{row.achievement || '-'}</td>
                                <td className="text-center">{row.productivity || '-'}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default DailyAcquisitionPerformance;
